import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import NavBar from "./NavBar";

export const ApplicationLayout = (props: any) => (
  <>
    <NavBar hideMobileMenu={props.hideMobileMenu} />
    {props.sidebar != 0 && <Sidebar type={props.sidebar} isJoint={props.isJoint} />}
    <Outlet />
  </>
);
